<template>
<div class="footer">
  <div class="footer-info">
    <div class="info-about">
      <span class="about-link" @click="toAbout(item.id)" v-for="(item,index) in footerData" :key="index">{{item.title}}</span>
    </div>
    <div class="info-record">
      <a href="https://beian.miit.gov.cn">京ICP备19026690号-1</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Footer",
  data(){
    return{
      footerData:[]
    }
  },
  methods:{
     async getFootsList(){
            var result = await this.$http.home.getFootsList()
            if(result.code==200){
              this.footerData = result.data
            }
        },
        toAbout(path){
          this.$router.push(`/about/${path}`)
          
        }
  },
  mounted(){
    this.getFootsList()
     window.addEventListener("click", this.clickOther);
  }

  
}
</script>

<style lang="less">
.footer {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 20px;
  border-top: 2px solid #c5c3c3;
  background: #fff;

  .footer-info {
    height: 130px;
    background-color: #c3c3c3;
    margin-top: 20px;
    padding-top: 30px;
    padding-bottom: 20px;
    text-align: center;
    font-size: 30px;

    .info-about {
      .about-link {
        margin:0 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
